import { render, staticRenderFns } from "./AgentAnnuityPriceDetailForm.vue?vue&type=template&id=1e77480a&"
import script from "./AgentAnnuityPriceDetailForm.vue?vue&type=script&lang=js&"
export * from "./AgentAnnuityPriceDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./AgentAnnuityPriceDetailForm.vue?vue&type=style&index=0&id=1e77480a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports